module.exports = __webpack_public_path__ + "img/img-28.3c939f31.png";